<template>
<div class="chapter">
<div class="inner_page">
<p class="chapt_heada"><a id="page_xxii"></a><a id="page_xxiii"></a><a href="#/Contents#int_4" id="rint_4">N<span class="small">OTES ON</span> P<span class="small">RONUNCIATION</span></a></p>
<p class="center"><img alt="" src="images/note.jpg"/></p>
<p class="noindent">S<span class="small">EVERAL OF THE</span> G<span class="small">AELIC</span> place names used in the text are followed by their English pronunciation – or rather, a best effort at this. One problem is that the Gaelic sound “<b>ch</b>” does not exist in English. In the text the sound is represented by the letter combination “<b>hh</b>.” Example: lo<b>ch </b>(lake) = lo<b>hh, </b>not lo<b>ck</b>. Try the <b>hh </b>sound while breathing out and with a little gargle. Or try the German “<b>ach</b>” as if it was in the non-word <b>lawch</b>ful.</p>
<p class="indent">Also, in Gaelic, the first syllable of a word almost always gets the emphasis. Example: <b>Dur</b>ness, not Dur<b>ness</b>. There are a few exceptions as in Loch<b>in</b>ver, but not many. Additional information on Gaelic pronunciation is provided in Appendix III.</p>
<p class="center">* * *</p>
<p class="indent">In this book, Celtic knots appear below the title of each chapter as decoration. Speculation has it that similar knotwork decorating many seventh to ninth century Celtic Christian manuscripts was symbolic of the interconnectedness and continuity of life.</p>
<p class="center" id="page_xxiv"><img alt="" src="images/map3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NotesonPronunciation.vue?26d6ddff